import React from 'react';

export const htmlParser = {
  /**
   * @method getAsReactComponent
   * @param {string} htmlString a string which contains html content
   * @param {string} parentTag the type name of the parent component
   * @returns {ReactComponent|ReactComponent[]} returns a ReactComponent of the type of 'parentTag' or an array of ReactComponents if no 'parentTag' was provided
   */
  getAsReactComponent( htmlString, parentTag ) {
    const substringOccurrences = htmlString.countSubstringOccurrences( 0, '<', '>' );
    const tagAmount = substringOccurrences.count / 4; //one tag contains 4 lace braces
    const result = tagAmount > 0 ? [htmlString.getContentBetween( -1, substringOccurrences.occurrences['<'].positions[0] )] : htmlString;

    for( let i = 0; i < tagAmount; i++ ) {
      const position = i * 2;
      const subComponent = this.getSubComponent( substringOccurrences, position );

      result.push( subComponent );
      result.push( htmlString.getContentBetween( substringOccurrences.occurrences['>'].positions[position + 1], substringOccurrences.occurrences['<'].positions[position + 2] || htmlString.length ) );
    }
    return parentTag ? React.createElement( parentTag, null, result ) : result;
  },
  /**
   * @method getSubComponent
   * @param {object} occurrences an object which contains all occurrences of the tags
   * @param {number} index the number of the component
   * @returns {ReactComponent} returns a ReactComponent
   */
  getSubComponent( occurrences, index ) {
    const tag = occurrences.content.getContentBetween( occurrences.occurrences['<'].positions[index], occurrences.occurrences['>'].positions[index] );
    const content = occurrences.content.getContentBetween( occurrences.occurrences['>'].positions[index], occurrences.occurrences['<'].positions[index + 1] );
    
    if( tag.includes( 'script' ) ) {
      console.warn( 'Scripts are not allowed' );
      return null;
    }

    return React.createElement( tag, { key: index }, content );
  },
  /**
   * @method removeHtmlTags
   * @param {string} htmlString a string which contains html content
   * @returns {string} returns the htmlString without any html tags
   */
  removeHtmlTags( htmlString ) {
    const substringOccurrences = htmlString.countSubstringOccurrences( 0, '<', '>' );
    const tagAmount = substringOccurrences.count / 4; //one tag contains 4 lace braces
    let result = tagAmount > 0 ? htmlString.getContentBetween( -1, substringOccurrences.occurrences['<'].positions[0] ) : htmlString;

    for( let i = 0; i < tagAmount; i++ ) {
      const position = i * 2;
      result = result + htmlString.getContentBetween( substringOccurrences.occurrences['>'].positions[position], substringOccurrences.occurrences['<'].positions[position + 1] );
      result = result + htmlString.getContentBetween( substringOccurrences.occurrences['>'].positions[position + 1], substringOccurrences.occurrences['<'].positions[position + 2] || htmlString.length );
    }

    return result;
  }
};